import React, { useEffect } from "react";
import { useState } from "react";
import { Typography } from "@mui/material";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { Fragment } from "react";
import "./BusinessProfileForm.css";
import { useDispatch, useSelector } from "react-redux";
import { chgUserProfile, getBusinessEntityProfile, getUser } from "../../../State/Auth/Action";

const BusinessProfileForm = () => {
  const [profileData, setProfileData] = useState({
    emailId: "",
    gstno: "",
    panno: "",
    tanno: "",
    tradeName: "",
    proprietorName: "",
    propHomeAddress: "",
    businessType: "",
    businessAddress: "",
    businessCity: "",
    businessDistrict: "",
    businessState: "",
    phoneNo: "",
    mobileNo: "",
    mobileNoSecondary: "",
    mobileNoWhatsApp: "",
  });
  const dispatch = useDispatch();
  const { auth } = useSelector((store) => store);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      profileData,
      reqJWT: auth?.jwt?.access_token,
    };
    const data2={
      accessToken: auth?.jwt?.access_token,
      emailId: auth?.user?.emailid,
    }
    dispatch(chgUserProfile(data)).then(()=>{
      dispatch(getUser(data2));
      handleClickOpen();
    });
  };

  useEffect(()=>{
    const data={
      reqJWT:auth?.jwt?.access_token
    }
    dispatch(getBusinessEntityProfile(data)).then(()=>{
      if(auth?.entity!=null){
        setProfileData(auth?.entity);
      }else{
        handleClickOpen2();
      }
    });
  },[auth?.jwt?.access_token]);

  return (
    <Fragment className="createProductContainer ">
      {(auth?.user?.firstname && (auth?.user?.role==='ADMIN' || auth?.user?.role==='MANAGER') || auth?.user?.role==='WHOLESALER' || auth?.user?.role==='RETAILER') ? (
      <Typography
        variant="h3"
        sx={{ textAlign: "center" }}
        className="py-10 text-center "
      >
        Profile Page
      </Typography>
      ):(<div>Not Login</div>)}
      {(auth?.user?.firstname && (auth?.user?.role==='ADMIN' || auth?.user?.role==='MANAGER' || auth?.user?.role==='WHOLESALER' || auth?.user?.role==='RETAILER')) ? (
      <form
        onSubmit={handleSubmit}
        className="createProductContainer min-h-screen"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email Id"
              name="emailId"
              value={auth?.user?.emailid}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="GST Number"
              name="gstno"
              value={profileData.gstno}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="TAN Nubmer"
              name="tanno"
              value={profileData.tanno}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="PAN Number"
              name="panno"
              value={profileData.panno}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Trade Name"
              name="tradeName"
              value={profileData.tradeName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Proprietor Name"
              name="proprietorName"
              value={profileData.proprietorName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Proprietor Home Address"
              name="propHomeAddress"
              value={profileData.propHomeAddress}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Business Type</InputLabel>
              <Select
                name="businessType"
                value={profileData.businessType}
                onChange={handleChange}
                label="Business Type"
              >
                <MenuItem value="Proprietor">Proprietor</MenuItem>
                <MenuItem value="Farm">Farm</MenuItem>
                <MenuItem value="Company">Company</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              fullWidth
              label="Business Address"
              name="businessAddress"
              value={profileData.businessAddress}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              fullWidth
              label="Business City"
              name="businessCity"
              value={profileData.businessCity}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Business District</InputLabel>
              <Select
                name="businessDistrict"
                value={profileData.businessDistrict}
                onChange={handleChange}
                label="Business District"
              >
                {/*<MenuItem value="Deoghar">Deoghar</MenuItem>*/}
                <MenuItem value="Giridih">Giridih</MenuItem>
                {/*<MenuItem value="Dhanbad">Dhanbad</MenuItem>*/}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Business State</InputLabel>
              <Select
                name="businessState"
                value={profileData.businessState}
                onChange={handleChange}
                label="Business State"
              >
                {/*<MenuItem value="Bihar">Bihar</MenuItem>*/}
                <MenuItem value="Jharkhand">Jharkhand</MenuItem>
                {/*<MenuItem value="UP">Utter Pradesh</MenuItem>*/}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              fullWidth
              label="Phone Number"
              name="phoneNo"
              value={profileData.phoneNo}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              fullWidth
              label="Mobile Number"
              name="mobileNo"
              value={profileData.mobileNo}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              fullWidth
              label="Other Mobile Number"
              name="mobileNoSecondary"
              value={profileData.mobileNoSecondary}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6} sm={8}>
            <TextField
              fullWidth
              label="Business WhatsApp Mobile Number"
              name="mobileNoWhatsApp"
              value={profileData.mobileNoWhatsApp}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{ p: 0.7 }}
              color="primary"
              size="large"
              type="submit"
            >
              Save Profile
            </Button>
          </Grid>
        </Grid>
      </form>
      ):(<div></div>)}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Profile is save.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Data loading error.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose2} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>


    </Fragment>
    
  );
};

export default BusinessProfileForm;
